<template>
    <div>
      <ViewForm v-if="!$store.getters.cusId" :is-open="true" />
      <ViewFormUser v-else :is-open="true" />
    </div>
  </template>
  <script>
  import ViewForm from '@/views/center-business/purchase/order/csg-admin';
  import ViewFormUser from '@/views/center-business/purchase/order/csg';
  export default {
    name: 'BusinessPurchaseOrderCsgAdminIndex',
    components: {
      ViewForm,
      ViewFormUser
    },
  };
  </script>
